// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1VI_5","productName":"Table_productName__1PQxw"};